export default "__VITE_ASSET__CJTKl_JI__"